import React, { Fragment, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import PropTypes from 'prop-types';

import {
  Avatar,
  Box,
  Button,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  Chip,
  makeStyles,
  colors
} from '@material-ui/core';

import NavItem from './NavItem';

import { AiFillApi } from "react-icons/ai";
import EqualizerIcon from '@material-ui/icons/Equalizer';
import HistoryIcon from '@material-ui/icons/History';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import { AiFillTool } from "react-icons/ai";
import { MdManageAccounts } from "react-icons/md";
import { MdEngineering } from "react-icons/md";

const items = [
  {
    href: '/mon/locations',
    icon: AiFillApi,
    title: 'Ponto de Instalação',
    color: colors.teal['A400'],
    profile: 'MON'
  },
  {
    href: '/mon/alarms',
    icon: NotificationsActiveIcon,
    title: 'Central de Alarme',
    color: colors.teal['A400'],
    profile: 'MON'
  },
  {
    href: '/mon/history',
    icon: HistoryIcon,
    title: 'Histórico de Alarme',
    color: colors.teal['A400'],
    profile: 'MON'
  },
  {
    href: '/mon/dashboard',
    icon: EqualizerIcon,
    title: 'Relatório de Alarme',
    color: colors.teal['A400'],
    profile: 'MON'
  },

  {
    href: '/mon/locations',
    icon: AiFillApi,
    title: 'Ponto de Instalação',
    color: colors.teal['A400'],
    profile: 'MAN'
  },
  {
    href: '/mon/alarms',
    icon: NotificationsActiveIcon,
    title: 'Central de Alarme',
    color: colors.teal['A400'],
    profile: 'MAN'
  },
  {
    href: '/mon/history',
    icon: HistoryIcon,
    title: 'Histórico de Alarme',
    color: colors.teal['A400'],
    profile: 'MAN'
  },
  {
    href: '/mon/dashboard',
    icon: EqualizerIcon,
    title: 'Relatório de Alarme',
    color: colors.teal['A400'],
    profile: 'MAN'
  },
  {
    href: '/sup/main',
    icon: AiFillTool,
    title: 'Assistência Técnica',
    color: colors.orange[500],
    profile: 'MAN'
  },
  {
    href: '/mon/locations',
    icon: AiFillApi,
    title: 'Ponto de Instalação',
    color: colors.teal['A400'],
    profile: 'ADM'
  },
  {
    href: '/mon/alarms',
    icon: NotificationsActiveIcon,
    title: 'Central de Alarme',
    color: colors.teal['A400'],
    profile: 'ADM'
  },
  {
    href: '/mon/history',
    icon: HistoryIcon,
    title: 'Histórico de Alarme',
    color: colors.teal['A400'],
    profile: 'ADM'
  },
  {
    href: '/mon/dashboard',
    icon: EqualizerIcon,
    title: 'Relatório de Alarme',
    color: colors.teal['A400'],
    profile: 'ADM'
  },
  {
    href: '/adm/main',
    icon: MdManageAccounts,
    title: 'Administração',
    color: colors.blue[400],
    profile: 'ADM'
  },

  {
    href: '/mon/locations',
    icon: AiFillApi,
    title: 'Ponto de Instalação',
    color: colors.teal['A400'],
    profile: 'ENG'
  },
  {
    href: '/mon/alarms',
    icon: NotificationsActiveIcon,
    title: 'Central de Alarme',
    color: colors.teal['A400'],
    profile: 'ENG'
  },
  {
    href: '/mon/history',
    icon: HistoryIcon,
    title: 'Histórico de Alarme',
    color: colors.teal['A400'],
    profile: 'ENG'
  },
  {
    href: '/mon/dashboard',
    icon: EqualizerIcon,
    title: 'Relatório de Alarme',
    color: colors.teal['A400'],
    profile: 'ENG'
  },
  {
    href: '/adm/main',
    icon: MdManageAccounts,
    title: 'Administração',
    color: colors.blue[400],
    profile: 'ENG'
  },

  {
    href: '/mon/locations',
    icon: AiFillApi,
    title: 'Ponto de Instalação',
    color: colors.teal['A400'],
    profile: 'AAD'
  },
  {
    href: '/mon/alarms',
    icon: NotificationsActiveIcon,
    title: 'Central de Alarme',
    color: colors.teal['A400'],
    profile: 'AAD'
  },
  {
    href: '/mon/history',
    icon: HistoryIcon,
    title: 'Histórico de Alarme',
    color: colors.teal['A400'],
    profile: 'AAD'
  },
  {
    href: '/mon/dashboard',
    icon: EqualizerIcon,
    title: 'Relatório de Alarme',
    color: colors.teal['A400'],
    profile: 'AAD'
  },
  {
    href: '/mgt/main',
    icon: MdEngineering,
    title: 'Manutenção',
    color: colors.cyan[400],
    profile: 'AAD'
  },

];

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
}));

const NavBar = ({ onMobileClose, openMobile }) => {

  const classes = useStyles();

  const [user, setUser] = useState({
    avatar: localStorage.getItem('avatar'),
    firstname: localStorage.getItem('firstname'),
    lastname: localStorage.getItem('lastname'),
    company: localStorage.getItem('company'),
    profile: localStorage.getItem('profile')
  });

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
      setUser(localStorage.getItem('user'));
    }
  }, []);

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    >

      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        p={1}
      >
        <Avatar
          className={classes.avatar}
          component={RouterLink}
          variant="circle"
          src={`/static/images/avatars/`}
          to="/mon/main"
        />
        <Typography
          className={classes.name}
          color="secondary"
          variant="body2"
        >
          {user.firstname} {user.lastname}
        </Typography>
        <Chip
          size="small"
          color="primary"
          label={`Perfil de acesso é ` + user.profile + `.`}
        />
      </Box>
      <Divider />
      <Box p={1}>
        <List>
          {items.map((item) => (
            (item.profile == localStorage.getItem('profile')) ? (
              <NavItem
                href={item.href}
                key={item.title}
                title={item.title}
                icon={item.icon}
                color={item.color}
              />) : ('')
          ))}
        </List>
      </Box>
      <Box flexGrow={1} hidden />
      <Box
        hidden={true || localStorage.getItem('profile') === 'MON' || localStorage.getItem('profile') === 'MAN' || localStorage.getItem('profile') === 'AST'}
        p={1}
        m={1}
        bgcolor="background.dark"
      >
        <Typography
          align="center"
          gutterBottom
          variant="h4"
        >
          Sair da Área de Monitoramento?
        </Typography>

        <Typography
          align="center"
          variant="body2"
        >
          Aqui Você Entra na Área de Administração do Sistema
        </Typography>
        <Box
          display="flex"
          justifyContent="center"
          mt={1}
        >
          <Button
            color="secondary"
            component="a"
            variant="contained"
            href="/adm/main">
            Administração
          </Button>
        </Box>
      </Box>

      <Box
        hidden={true || localStorage.getItem('profile') === 'MON'}
        p={1}
        m={1}
        bgcolor="background.dark"
      >
        <Typography
          align="center"
          gutterBottom
          variant="h4"
        >
          Sair da Área de Monitoramento?
        </Typography>

        <Typography
          align="center"
          variant="body2"
        >
          Aqui Você Entra na Área de Assistência Técnica
        </Typography>
        <Box
          display="flex"
          justifyContent="center"
          mt={1}
        >
          <Button
            color="secondary"
            component="a"
            href="/sup/main"
            variant="contained">
            ASSISTÊNCIA TÉCNICA
          </Button>
        </Box>
      </Box>

    </Box>
  );

  return (
    <Fragment>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </Fragment>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

NavBar.defaultProps = {
  onMobileClose: () => { },
  openMobile: false
};

export default NavBar;
